import { useEffect } from 'react'

import { useSidebarContext } from './sidebar-context'

export function useSidebar() {
    const { isOpen, setIsOpen, toggleSidebar } = useSidebarContext()

    const openSidebar = () => setIsOpen(true)
    const closeSidebar = () => setIsOpen(false)

    return {
        isOpen,
        setIsOpen,
        toggleSidebar,
        openSidebar,
        closeSidebar,
    }
}

export function useSidebarAutoHide() {
    const { closeSidebar } = useSidebar()

    useEffect(() => {
        closeSidebar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { closeSidebar }
}
